import axios from 'axios';
import apiConfig from '../api.config';

export default function updateHotelsRequest(data) {
  const {
    host,
    URIs: { hotels },
  } = apiConfig;

  const uri = `${host}${hotels}/${data?.hotelId}`;

  return axios
    .put(uri, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
